import React from 'react';
import { motion } from 'framer-motion';
export function ProblemSection() {
  return <section className="py-20 px-6 bg-white" data-id="element-109">
      <div className="max-w-4xl mx-auto text-center" data-id="element-110">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} data-id="element-111">
          <h2 className="text-3xl md:text-4xl font-bold mb-8" data-id="element-112">
            La Tormenta Perfecta
          </h2>
          <div className="text-lg md:text-xl leading-relaxed text-gray-700 space-y-6 text-left md:text-center" data-id="element-113">
            <p data-id="element-114">
              Después de los 50, la caída del estrógeno y el aumento del
              cortisol crean una "tormenta perfecta" de inflamación. Tu cuerpo
              entra en modo de supervivencia.
            </p>
            <p className="font-medium text-brand-green" data-id="element-115">
              Cada vez que intentas una dieta extrema o pasas horas haciendo
              cardio, tu cerebro interpreta que hay una emergencia y ordena
              almacenar grasa abdominal para protegerse.
            </p>
            <p data-id="element-116">
              Por eso, aunque comas menos, la báscula no se mueve y tu energía
              desaparece a las 3 de la tarde. Estás luchando contra tu propia
              biología, y esa es una batalla que no puedes ganar con fuerza de
              voluntad.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}